import { useState } from "react";

const SOURCE_FILTERS = [
  { key: "all", label: "הכל" },
  { key: "advice", label: "📋 טרום-ייעוץ" },
  { key: "holdings", label: "📦 אחזקות" },
  { key: "retirement", label: "📐 פרישה" },
];

export default function ClientSidebar({
  clients,
  sourceFilter = "all",
  onSourceFilterChange,
  activeIds,
  onSelect,
  onToggleCompare,
  onRemove,
  onAddNew,
  onImport,
  onOpenFilesManager,
  onSwitchDataset,
  onRemoveDataset,
  collapsed,
  onToggleCollapse,
  onSignOut,
  onStorageSettings,
  onAdmin,
  isAdmin,
  email,
  onOpenLog,
  onGoHome,
  onBulkSend,
}) {

  const collapsedBtn = {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: 16,
    padding: "6px 4px",
    display: "flex",
    justifyContent: "center",
  };

  if (collapsed) {
    return (
      <div style={{
        width: 40,
        background: "white",
        borderRight: "1px solid #e2e8f0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: 12,
        transition: "width 0.25s ease",
        flexShrink: 0,
        userSelect: "none",
        gap: 2,
      }}>
        {/* Expand sidebar */}
        <button
          onClick={onToggleCollapse}
          title="פתח סרגל"
          style={collapsedBtn}
        >☰</button>

        {/* Search hint */}
        <button
          onClick={onToggleCollapse}
          title="חיפוש לקוח"
          style={collapsedBtn}
        >🔍</button>

        {/* Activity log */}
        {onOpenLog && (
          <button
            onClick={onOpenLog}
            title="יומן פעילות"
            style={collapsedBtn}
          >📋</button>
        )}

        {/* Files manager */}
        {onOpenFilesManager && (
          <button
            onClick={onOpenFilesManager}
            title="ניהול קבצים"
            style={collapsedBtn}
          >🗂️</button>
        )}

        {/* Home */}
        {onGoHome && (
          <button
            onClick={onGoHome}
            title="חזרה למסך הבית"
            style={collapsedBtn}
          >🏠</button>
        )}

      </div>
    );
  }

  const [search, setSearch] = useState("");
  const filteredClients = search.trim()
    ? clients.filter(c =>
        (c.fileInfo?.client || "").toLowerCase().includes(search.trim().toLowerCase()) ||
        (c.fileInfo?.clientId || "").toLowerCase().includes(search.trim().toLowerCase()))
    : clients;

  return (
    <div style={{
      width: 260,
      background: "white",
      borderRight: "1px solid #e2e8f0",
      display: "flex",
      flexDirection: "column",
      transition: "width 0.25s ease",
      flexShrink: 0,
      overflowY: "auto",
    }}>
      {/* Header */}
      <div style={{
        padding: "12px 14px",
        borderBottom: "1px solid #e2e8f0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: "#f8fafc",
        flexShrink: 0,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }} />
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          {onBulkSend && (
            <button
              onClick={onBulkSend}
              title="שליחת דוח חודשי לכל הלקוחות במייל"
              style={{
                fontSize: 11, padding: "4px 8px", height: 26,
                background: "#cffafe", border: "none", cursor: "pointer",
                color: "#0e7490", borderRadius: 6, fontWeight: 700,
                whiteSpace: "nowrap", display: "inline-flex", alignItems: "center", gap: 3,
              }}
            >
              <span>📤</span><span>דוח חודשי</span>
            </button>
          )}
          {onOpenLog && (
            <button
              onClick={onOpenLog}
              title="יומן פעולות"
              style={{
                fontSize: 11, padding: "4px 8px", height: 26,
                background: "#ede9fe", border: "none", cursor: "pointer",
                color: "#7c3aed", borderRadius: 6, fontWeight: 700,
                whiteSpace: "nowrap", display: "inline-flex", alignItems: "center", gap: 3,
              }}
            >
              <span>📋</span><span>יומן</span>
            </button>
          )}
          {onOpenFilesManager && (
            <button
              onClick={onOpenFilesManager}
              title="ניהול קבצים"
              style={{
                fontSize: 11, padding: "4px 8px", height: 26,
                background: "#e0f2fe", border: "none", cursor: "pointer",
                color: "#0284c7", borderRadius: 6, fontWeight: 700,
                whiteSpace: "nowrap", display: "inline-flex", alignItems: "center", gap: 3,
              }}
            >
              <span>🗂️</span><span>קבצים</span>
            </button>
          )}
          <span
            onClick={onToggleCollapse}
            style={{ fontSize: 13, fontWeight: 800, color: "#1e293b", cursor: "pointer" }}
            title="כווץ סרגל"
          >לקוחות</span>
          <button
            onClick={onToggleCollapse}
            style={{
              background: "transparent", border: "none", cursor: "pointer",
              fontSize: 12, color: "#94a3b8", padding: 2,
            }}
            title="כווץ סרגל"
          >◀</button>
        </div>
      </div>

      {/* Search + source filter */}
      {clients.length > 0 && (
        <div style={{ padding: "7px 10px", borderBottom: "1px solid #e2e8f0", flexShrink: 0, display: "flex", flexDirection: "column", gap: 6 }}>
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="🔍 שם / ת.ז..."
            style={{
              width: "100%", padding: "5px 8px",
              border: "1px solid #e2e8f0", borderRadius: 6,
              fontSize: 12, direction: "rtl", outline: "none",
              background: "#f8fafc", boxSizing: "border-box",
            }}
          />
          {onSourceFilterChange && (
            <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
              {SOURCE_FILTERS.map(f => {
                const active = sourceFilter === f.key;
                return (
                  <button
                    key={f.key}
                    onClick={() => onSourceFilterChange(f.key)}
                    style={{
                      flex: 1, fontSize: 10, padding: "3px 4px",
                      background: active ? "#4338ca" : "#f1f5f9",
                      color: active ? "white" : "#64748b",
                      border: "1px solid " + (active ? "#4338ca" : "#e2e8f0"),
                      borderRadius: 5, cursor: "pointer",
                      fontWeight: active ? 700 : 500, whiteSpace: "nowrap",
                    }}
                  >
                    {f.label}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Client list */}
      <div style={{ flex: 1, overflowY: "auto" }}>
        {clients.length === 0 && (
          <div style={{ padding: "20px 14px", fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
            אין לקוחות טעונים
          </div>
        )}
        {clients.length > 0 && filteredClients.length === 0 && (
          <div style={{ padding: "16px 14px", fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
            לא נמצאו לקוחות
          </div>
        )}
        {(() => {
          const visibleClients = filteredClients;
          return visibleClients.map((client) => {
          const isActive = activeIds.includes(client.id);
          const compareSlot = activeIds.indexOf(client.id); // 0 = A, 1 = B, -1 = not comparing
          const isCompareMode = activeIds.length === 2;

          return (
            <div
              key={client.clientId || client.id}
              style={{
                padding: "10px 14px",
                borderBottom: "1px solid #f1f5f9",
                background: isActive ? "#eff6ff" : "white",
                transition: "background 0.15s",
              }}
            >
              {/* Client name row */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
                <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                  {isActive && isCompareMode && compareSlot >= 0 && (
                    <span style={{
                      fontSize: 10, fontWeight: 800,
                      background: compareSlot === 0 ? "#4338ca" : "#0891b2",
                      color: "white", borderRadius: 4, padding: "1px 5px",
                    }}>
                      {compareSlot === 0 ? "A" : "B"}
                    </span>
                  )}
                  {isActive && !isCompareMode && (
                    <span style={{ fontSize: 10, color: "#16a34a", fontWeight: 800 }}>●</span>
                  )}
                  {client.hasHoldings && (
                    <span title="אחזקות" style={{ fontSize: 9, background: "#ecfdf5", color: "#047857", borderRadius: 4, padding: "1px 4px", fontWeight: 700 }}>📦</span>
                  )}
                  {client.hasAdvice && (
                    <span title="טרום-ייעוץ" style={{ fontSize: 9, background: "#eef2ff", color: "#4338ca", borderRadius: 4, padding: "1px 4px", fontWeight: 700 }}>📋</span>
                  )}
                </div>
                <button
                  onClick={() => onRemove(client.id)}
                  style={{
                    background: "transparent", border: "none", cursor: "pointer",
                    fontSize: 11, color: "#94a3b8", padding: "0 2px",
                    lineHeight: 1,
                  }}
                  title="הסר לקוח"
                >
                  ✕
                </button>
              </div>

              {/* Client info */}
              <div
                style={{ cursor: "pointer" }}
                onClick={() => onSelect(client.id)}
              >
                <div style={{ fontSize: 13, fontWeight: 800, color: "#1e293b", marginBottom: 2, textAlign: "right" }}>
                  {client.fileInfo?.client || "לקוח"}
                </div>
                <div style={{ fontSize: 10, color: "#64748b", marginBottom: 2, textAlign: "right" }}>
                  {client.fileInfo?.name}
                </div>
                <div style={{ fontSize: 10, color: "#94a3b8", textAlign: "right" }}>
                  {client.fileInfo?.fundsCount} מוצרים ·{" "}
                  {new Date(client.addedAt).toLocaleDateString("he-IL", { day: "2-digit", month: "2-digit", year: "2-digit" })}
                </div>
              </div>

              {/* Dataset switcher */}
              {client.datasets?.length > 1 && (
                <div style={{ display: "flex", gap: 4, marginTop: 6, flexWrap: "wrap", justifyContent: "flex-end" }}>
                  {client.datasets.map((ds, idx) => {
                    const label = ds.taarichBitzua
                      || new Date(ds.addedAt).toLocaleDateString("he-IL", { day: "2-digit", month: "2-digit", year: "2-digit" });
                    const isActiveDs = idx === client.activeDatasetIndex;
                    return (
                      <div key={`${ds.id || 'ds'}_${idx}`} style={{ display: "flex", alignItems: "center", gap: 0 }}>
                        <button
                          onClick={(e) => { e.stopPropagation(); onSwitchDataset(client.id, idx); }}
                          style={{
                            fontSize: 9, padding: "2px 6px",
                            background: isActiveDs ? "#4338ca" : "#f1f5f9",
                            color: isActiveDs ? "white" : "#64748b",
                            border: "1px solid " + (isActiveDs ? "#4338ca" : "#e2e8f0"),
                            borderRadius: "4px 0 0 4px", cursor: "pointer",
                            fontWeight: isActiveDs ? 700 : 400,
                          }}
                          title={ds.fileInfo?.name || ""}
                        >
                          {label}
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (window.confirm(`למחוק את הנתונים מתאריך ${label}?`)) {
                              onRemoveDataset?.(client.id, idx);
                            }
                          }}
                          style={{
                            fontSize: 8, padding: "2px 4px",
                            background: isActiveDs ? "#3730a3" : "#f1f5f9",
                            color: isActiveDs ? "#fca5a5" : "#94a3b8",
                            border: "1px solid " + (isActiveDs ? "#4338ca" : "#e2e8f0"),
                            borderLeft: "none",
                            borderRadius: "0 4px 4px 0", cursor: "pointer",
                          }}
                          title="מחק טעינה זו"
                        >
                          ✕
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Action buttons */}
              <div style={{ display: "flex", gap: 6, marginTop: 8, justifyContent: "flex-end" }}>
                {!isActive && (
                  <button
                    onClick={() => onSelect(client.id)}
                    style={{
                      fontSize: 10, padding: "3px 8px",
                      background: "#4338ca", color: "white",
                      border: "none", borderRadius: 5, cursor: "pointer",
                      fontWeight: 700,
                    }}
                  >
                    בחר
                  </button>
                )}
                <button
                  onClick={() => onToggleCompare(client.id)}
                  style={{
                    fontSize: 10, padding: "3px 8px",
                    background: isActive && isCompareMode && compareSlot === 1 ? "#0891b2" : "white",
                    color: isActive && isCompareMode && compareSlot === 1 ? "white" : "#475569",
                    border: "1px solid #e2e8f0",
                    borderRadius: 5, cursor: "pointer",
                  }}
                  title={activeIds.includes(client.id) && activeIds.length > 1 ? "הסר מהשוואה" : "הוסף להשוואה"}
                >
                  השווה
                </button>
              </div>
            </div>
          );
          });
        })()}
      </div>

      {/* Footer: Backup, Storage, Sign Out */}
      <div style={{
        padding: "12px 14px",
        borderTop: "1px solid #e2e8f0",
        background: "#f8fafc",
        display: "flex",
        flexDirection: "column",
        gap: 6,
        flexShrink: 0
      }}>
        <div style={{ display: "flex", gap: 6 }}>
          <button
            onClick={async () => {
              const { exportWorkspace } = await import("../utils/storage");
              await exportWorkspace();
            }}
            style={{
              fontSize: 11, padding: "5px 0",
              background: "white", color: "#475569",
              border: "1px solid #cbd5e1", borderRadius: 6, cursor: "pointer",
              fontWeight: 600, flex: 1, textAlign: "center"
            }}
          >
            💾 גיבוי
          </button>
          <button
            onClick={() => document.getElementById("importBackupInput").click()}
            style={{
              fontSize: 11, padding: "5px 0",
              background: "white", color: "#475569",
              border: "1px solid #cbd5e1", borderRadius: 6, cursor: "pointer",
              fontWeight: 600, flex: 1, textAlign: "center"
            }}
          >
            📂 שחזור
          </button>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <button
            onClick={onStorageSettings}
            style={{
              fontSize: 11, padding: "5px 0",
              background: "white", color: "#475569",
              border: "1px solid #cbd5e1", borderRadius: 6, cursor: "pointer",
              fontWeight: 600, flex: 1, textAlign: "center"
            }}
          >
            ☁ אחסון
          </button>
          <button
            onClick={onSignOut}
            title={email}
            style={{
              fontSize: 11, padding: "5px 0",
              background: "white", color: "#ef4444",
              border: "1px solid #fecaca", borderRadius: 6, cursor: "pointer",
              fontWeight: 600, flex: 1, textAlign: "center"
            }}
          >
            התנתקות
          </button>
        </div>
        {isAdmin && (
          <button
            onClick={onAdmin}
            style={{
              fontSize: 11, padding: "5px 0",
              background: "#1e293b", color: "white",
              border: "none", borderRadius: 6, cursor: "pointer",
              fontWeight: 600, width: "100%", textAlign: "center"
            }}
          >
            ⚙️ Admin
          </button>
        )}
        <input
          id="importBackupInput"
          type="file"
          accept=".pension,.json"
          style={{ display: "none" }}
          onChange={async (e) => {
            if (!e.target.files[0]) return;
            const { importWorkspace } = await import("../utils/storage");
            try {
              await importWorkspace(e.target.files[0]);
              alert("השחזור הושלם בהצלחה! האפליקציה תתרענן כעת.");
              window.location.reload();
            } catch (err) {
              alert("שגיאה בטעינת קובץ הגיבוי.");
            }
            e.target.value = "";
          }}
        />
      </div>
    </div>
  );
}

const collapsedBtn = {
  background: "transparent", border: "none", cursor: "pointer",
  fontSize: 16, padding: "7px 0", width: "100%",
  display: "flex", alignItems: "center", justifyContent: "center",
  color: "#64748b",
};
